import { Component, OnInit, ViewChild } from '@angular/core';
import { RootService } from 'src/app/services/root/root.service';
import { Price } from './models/price.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-prices',
  templateUrl: './prices.component.html',
  styleUrls: ['./prices.component.scss']
})
export class PricesComponent implements OnInit {

  dataSource = new MatTableDataSource<Price[]>();
  client;
  displayedColumns: string[];

  constructor(
    private rootservice: RootService,
    private spinner: NgxSpinnerService
  ) { }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this.spinner.show();
    this.client = JSON.parse(sessionStorage.getItem("session"));
    this.displayedColumns = this.client.dsSesion.ttsesion[0].tipo.toLowerCase() == 'vendedor' ? ['LC_numero', 'LC_fecha', 'LC_clien', 'LC_nombre', 'LC_pdf'] : ['LC_numero', 'LC_fecha', 'LC_pdf'];
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.rootservice.price().subscribe(res => {
      this.dataSource.data = res["lascot"];
    });

    this.spinner.hide();
  }

  /** Filter */
  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
